import { Helmet } from 'react-helmet'
import Header from '../../../../Components/Header'
import MainContent from './Maincontent'
const ADDList = () => {
  return (
     <div className='d-flex flex-column' style={{minHeight:'99.7vh'}}>

      <Helmet>
				<title>Accounting Dimension Details List</title>
			</Helmet>
    <Header />
    <MainContent />
    </div>
  )
}
export default ADDList